import styles from './RepaymentSummaryItem.module.css';
import { FormattedDate, FormattedMessage } from 'react-intl';
import NextRepaymentSummaryMessages from '../nextRepaymentSummary/NextRepaymentSummary.messages';
import messages from './RepaymentSummaryItem.messages';
import { MoneyWithDecimals } from '../moneyWithDecimals';
import { IwDynamicFormattedMessage } from '../../../iwDynamicFormattedMessage/IwDynamicFormattedMessage';
import { getDayOfWeek } from '@iwIntlProvider/MessagesHelper';

const RepaymentSummaryItem = ({
    amount,
    description,
    interval,
    value
}: {
    amount: number | null;
    description: React.ReactNode;
    value: string | number | null;
    interval?: string;
}) => {
    return (
        <div className={styles.RepaymentSummaryItem}>
            <div className={styles.nextRepaymentContainer}>
                <div className={styles.nextRepaymentLabel}>
                    <FormattedMessage {...NextRepaymentSummaryMessages.label} />
                </div>

                {amount !== null && (
                    <div className={styles.nextRepaymentDate}>
                        <RepayDate interval={interval} value={value} />
                    </div>
                )}
            </div>

            <div className={styles.amountLine}>
                <MoneyWithDecimals
                    integerWithSymbolClassName={styles.RepayMoneyInteger}
                    decimalWithSeparatorClassName={styles.RepayMoneyDecimals}
                    className={styles.RepayMoney}
                    value={amount!}
                />
            </div>

            {description && (
                <div className={styles.RepayDescription}>{description}</div>
            )}
        </div>
    );
};

// eslint-disable-next-line
export default RepaymentSummaryItem;

const RepayDate = ({
    value,
    interval
}: {
    value: string | number | null;
    interval?: string;
}) => {
    if (!value) {
        return null;
    }

    switch (interval) {
        case 'Weekly':
            const weekDay = (
                <IwDynamicFormattedMessage
                    messages={messages}
                    messageKey={getDayOfWeek(value)}
                />
            );
            return (
                <div className={styles.RepayDate}>
                    <FormattedMessage
                        {...messages.weekly}
                        values={{ weekDay }}
                    />
                </div>
            );

        case 'Monthly':
            return (
                <div className={styles.RepayDate}>
                    <FormattedMessage
                        {...messages.monthly}
                        values={{ monthDay: value }}
                    />
                </div>
            );

        default:
            return (
                <FormattedDate
                    day="numeric"
                    month="long"
                    year="numeric"
                    value={new Date(value)}
                />
            );
    }
};
